import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import UserCreateTab from './UserCreateTab';
import { userPropertiesType } from '../../types';

CreateUserRow.propTypes = {
    userProps: userPropertiesType.isRequired,
};

function CreateUserRow(props) {
    const {
        userProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-user-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}>
                <FontAwesomeIcon icon="plus" />&nbsp;{t('users.create-user')}
            </CreateButton>
            {isCreateVisible && <UserCreateTab userProps={userProps} hideHandler={() => setCreateVisible(false)} />}
        </div>
    );
}

export default withPrivileges([Privileges.USER_EDIT])(CreateUserRow);
